import { render } from "./TheFeatures.vue?vue&type=template&id=34674674&scoped=true"
import script from "./TheFeatures.vue?vue&type=script&lang=js"
export * from "./TheFeatures.vue?vue&type=script&lang=js"

import "./TheFeatures.vue?vue&type=style&index=0&id=34674674&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34674674"]])

export default __exports__